export const affiliateSummary = {
  affiliateSummary: "Affiliate Summary",
  affiliateSummaryCarryForward: "Affiliate Summary: Carry Forward",
  search: "Search",
  from: "From",
  to: "To",
  totalAffiliateUsers: "Total Affiliate Users",
  totalAffiliateWinLoss: "Total Affiliate Win/Loss",
  affiliateWinloss: "Affiliate Win/Loss",
  totalAffiliateBetAmount: "Total Affiliate Bet Amount",
  totalAffiliateAmount: "Total Affiliate Amount",
  accountName: "ACCOUNT NAME",
  username: "USERNAME",
  affiliateBetAmount: "AFFILIATE BET AMOUNT",
  showing: "Showing",
  results: "results",
  viewDetail: "View Detail",
  affiliateDetails: "Affiliate Details",
  level: "Level",
  totalDeposit: "Total Deposit",
  betAmount: "Bet Amount",
  settleAmount: "Settle Amount",
  winloss: "Win/Loss",
  affiliateAmount: "Affiliate Amount",
  withdrawAmount: "Withdraw Amount",
  carry_amount: "carry_amount",
};
